import { css } from '@emotion/core';
import { typography } from '../../../../styles/typography';

export const headline = css(typography.effra28, {
  verticalAlign: 'top',
});

export const items = css({
  marginTop: 19,
});

export const item = css({
  marginBottom: 11,

  '&:last-child': {
    marginBottom: 0,
  },
});

export const link = css({
  verticalAlign: 'top',

  span: {
    verticalAlign: 'top',
  },
});

export const headlineTextCss = css(typography.effra28);
